"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The RfpRowResponse model module.
 * @module model/RfpRowResponse
 * @version 2.7.64
 */
var RfpRowResponse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfpRowResponse</code>.
   * @alias module:model/RfpRowResponse
   */
  function RfpRowResponse() {
    _classCallCheck(this, RfpRowResponse);

    RfpRowResponse.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(RfpRowResponse, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>RfpRowResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfpRowResponse} obj Optional instance to populate.
     * @return {module:model/RfpRowResponse} The populated <code>RfpRowResponse</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfpRowResponse();

        if (data.hasOwnProperty('carrier_name')) {
          obj['carrier_name'] = _ApiClient["default"].convertToType(data['carrier_name'], 'String');
        }

        if (data.hasOwnProperty('carrier_reference')) {
          obj['carrier_reference'] = _ApiClient["default"].convertToType(data['carrier_reference'], 'String');
        }

        if (data.hasOwnProperty('contract')) {
          obj['contract'] = _ApiClient["default"].convertToType(data['contract'], 'String');
        }

        if (data.hasOwnProperty('destination_city')) {
          obj['destination_city'] = _ApiClient["default"].convertToType(data['destination_city'], 'String');
        }

        if (data.hasOwnProperty('destination_postal_code')) {
          obj['destination_postal_code'] = _ApiClient["default"].convertToType(data['destination_postal_code'], 'String');
        }

        if (data.hasOwnProperty('destination_state')) {
          obj['destination_state'] = _ApiClient["default"].convertToType(data['destination_state'], 'String');
        }

        if (data.hasOwnProperty('equipment')) {
          obj['equipment'] = _ApiClient["default"].convertToType(data['equipment'], 'String');
        }

        if (data.hasOwnProperty('flat_rate')) {
          obj['flat_rate'] = _ApiClient["default"].convertToType(data['flat_rate'], 'Number');
        }

        if (data.hasOwnProperty('freight_authority_vendor_relationship')) {
          obj['freight_authority_vendor_relationship'] = _ApiClient["default"].convertToType(data['freight_authority_vendor_relationship'], 'String');
        }

        if (data.hasOwnProperty('fsc')) {
          obj['fsc'] = _ApiClient["default"].convertToType(data['fsc'], 'String');
        }

        if (data.hasOwnProperty('fsc_ref')) {
          obj['fsc_ref'] = _ApiClient["default"].convertToType(data['fsc_ref'], 'String');
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('lane_policy_id')) {
          obj['lane_policy_id'] = _ApiClient["default"].convertToType(data['lane_policy_id'], 'String');
        }

        if (data.hasOwnProperty('lane_policy_name')) {
          obj['lane_policy_name'] = _ApiClient["default"].convertToType(data['lane_policy_name'], 'String');
        }

        if (data.hasOwnProperty('mode')) {
          obj['mode'] = _ApiClient["default"].convertToType(data['mode'], 'String');
        }

        if (data.hasOwnProperty('origin_city')) {
          obj['origin_city'] = _ApiClient["default"].convertToType(data['origin_city'], 'String');
        }

        if (data.hasOwnProperty('origin_postal_code')) {
          obj['origin_postal_code'] = _ApiClient["default"].convertToType(data['origin_postal_code'], 'String');
        }

        if (data.hasOwnProperty('origin_state')) {
          obj['origin_state'] = _ApiClient["default"].convertToType(data['origin_state'], 'String');
        }

        if (data.hasOwnProperty('rate_per_mile')) {
          obj['rate_per_mile'] = _ApiClient["default"].convertToType(data['rate_per_mile'], 'Number');
        }

        if (data.hasOwnProperty('rfp_lane')) {
          obj['rfp_lane'] = _ApiClient["default"].convertToType(data['rfp_lane'], 'String');
        }

        if (data.hasOwnProperty('row_identifier')) {
          obj['row_identifier'] = _ApiClient["default"].convertToType(data['row_identifier'], 'String');
        }
      }

      return obj;
    }
  }]);

  return RfpRowResponse;
}();
/**
 * @member {String} carrier_name
 */


RfpRowResponse.prototype['carrier_name'] = undefined;
/**
 * @member {String} carrier_reference
 */

RfpRowResponse.prototype['carrier_reference'] = undefined;
/**
 * @member {String} contract
 */

RfpRowResponse.prototype['contract'] = undefined;
/**
 * @member {String} destination_city
 */

RfpRowResponse.prototype['destination_city'] = undefined;
/**
 * @member {String} destination_postal_code
 */

RfpRowResponse.prototype['destination_postal_code'] = undefined;
/**
 * @member {String} destination_state
 */

RfpRowResponse.prototype['destination_state'] = undefined;
/**
 * @member {module:model/RfpRowResponse.EquipmentEnum} equipment
 */

RfpRowResponse.prototype['equipment'] = undefined;
/**
 * @member {Number} flat_rate
 */

RfpRowResponse.prototype['flat_rate'] = undefined;
/**
 * @member {String} freight_authority_vendor_relationship
 */

RfpRowResponse.prototype['freight_authority_vendor_relationship'] = undefined;
/**
 * @member {String} fsc
 */

RfpRowResponse.prototype['fsc'] = undefined;
/**
 * @member {String} fsc_ref
 */

RfpRowResponse.prototype['fsc_ref'] = undefined;
/**
 * @member {String} id
 */

RfpRowResponse.prototype['id'] = undefined;
/**
 * @member {String} lane_policy_id
 */

RfpRowResponse.prototype['lane_policy_id'] = undefined;
/**
 * @member {String} lane_policy_name
 */

RfpRowResponse.prototype['lane_policy_name'] = undefined;
/**
 * @member {module:model/RfpRowResponse.ModeEnum} mode
 */

RfpRowResponse.prototype['mode'] = undefined;
/**
 * @member {String} origin_city
 */

RfpRowResponse.prototype['origin_city'] = undefined;
/**
 * @member {String} origin_postal_code
 */

RfpRowResponse.prototype['origin_postal_code'] = undefined;
/**
 * @member {String} origin_state
 */

RfpRowResponse.prototype['origin_state'] = undefined;
/**
 * @member {Number} rate_per_mile
 */

RfpRowResponse.prototype['rate_per_mile'] = undefined;
/**
 * @member {String} rfp_lane
 */

RfpRowResponse.prototype['rfp_lane'] = undefined;
/**
 * @member {String} row_identifier
 */

RfpRowResponse.prototype['row_identifier'] = undefined;
/**
 * Allowed values for the <code>equipment</code> property.
 * @enum {String}
 * @readonly
 */

RfpRowResponse['EquipmentEnum'] = {
  /**
   * value: "AUTO_CARRIER"
   * @const
   */
  "AUTO_CARRIER": "AUTO_CARRIER",

  /**
   * value: "AUTOHAULER"
   * @const
   */
  "AUTOHAULER": "AUTOHAULER",

  /**
   * value: "B_TRAIN"
   * @const
   */
  "B_TRAIN": "B_TRAIN",

  /**
   * value: "BULK"
   * @const
   */
  "BULK": "BULK",

  /**
   * value: "CONESTOGA"
   * @const
   */
  "CONESTOGA": "CONESTOGA",

  /**
   * value: "CONTAINER"
   * @const
   */
  "CONTAINER": "CONTAINER",

  /**
   * value: "CONTAINER_BREAK_BULK"
   * @const
   */
  "CONTAINER_BREAK_BULK": "CONTAINER_BREAK_BULK",

  /**
   * value: "CONTAINER_STANDARD_20_FOOT"
   * @const
   */
  "CONTAINER_STANDARD_20_FOOT": "CONTAINER_STANDARD_20_FOOT",

  /**
   * value: "CONTAINER_STANDARD_40_FOOT"
   * @const
   */
  "CONTAINER_STANDARD_40_FOOT": "CONTAINER_STANDARD_40_FOOT",

  /**
   * value: "CONTAINER_FLAT_TRACK_20_FOOT"
   * @const
   */
  "CONTAINER_FLAT_TRACK_20_FOOT": "CONTAINER_FLAT_TRACK_20_FOOT",

  /**
   * value: "CONTAINER_FLAT_TRACK_40_FOOT"
   * @const
   */
  "CONTAINER_FLAT_TRACK_40_FOOT": "CONTAINER_FLAT_TRACK_40_FOOT",

  /**
   * value: "CONTAINER_HEAVY_TESTED_20_FOOT"
   * @const
   */
  "CONTAINER_HEAVY_TESTED_20_FOOT": "CONTAINER_HEAVY_TESTED_20_FOOT",

  /**
   * value: "CONTAINER_HIGH_CUBE_40_FOOT"
   * @const
   */
  "CONTAINER_HIGH_CUBE_40_FOOT": "CONTAINER_HIGH_CUBE_40_FOOT",

  /**
   * value: "CONTAINER_HIGH_CUBE_45_FOOT"
   * @const
   */
  "CONTAINER_HIGH_CUBE_45_FOOT": "CONTAINER_HIGH_CUBE_45_FOOT",

  /**
   * value: "CONTAINER_INSULATED"
   * @const
   */
  "CONTAINER_INSULATED": "CONTAINER_INSULATED",

  /**
   * value: "CONTAINER_ISO_TANK_20_FOOT"
   * @const
   */
  "CONTAINER_ISO_TANK_20_FOOT": "CONTAINER_ISO_TANK_20_FOOT",

  /**
   * value: "CONTAINER_ISO_TANK_24_FOOT"
   * @const
   */
  "CONTAINER_ISO_TANK_24_FOOT": "CONTAINER_ISO_TANK_24_FOOT",

  /**
   * value: "CONTAINER_ISO_TANK_40_FOOT"
   * @const
   */
  "CONTAINER_ISO_TANK_40_FOOT": "CONTAINER_ISO_TANK_40_FOOT",

  /**
   * value: "CONTAINER_OPEN_TOP_20_FOOT"
   * @const
   */
  "CONTAINER_OPEN_TOP_20_FOOT": "CONTAINER_OPEN_TOP_20_FOOT",

  /**
   * value: "CONTAINER_OPEN_TOP_40_FOOT"
   * @const
   */
  "CONTAINER_OPEN_TOP_40_FOOT": "CONTAINER_OPEN_TOP_40_FOOT",

  /**
   * value: "CONTAINER_REEFER_20_FOOT"
   * @const
   */
  "CONTAINER_REEFER_20_FOOT": "CONTAINER_REEFER_20_FOOT",

  /**
   * value: "CONTAINER_REEFER_40_FOOT"
   * @const
   */
  "CONTAINER_REEFER_40_FOOT": "CONTAINER_REEFER_40_FOOT",

  /**
   * value: "CONTAINER_REFRIGERATED"
   * @const
   */
  "CONTAINER_REFRIGERATED": "CONTAINER_REFRIGERATED",

  /**
   * value: "CONVEYOR"
   * @const
   */
  "CONVEYOR": "CONVEYOR",

  /**
   * value: "CURTAIN_SIDE"
   * @const
   */
  "CURTAIN_SIDE": "CURTAIN_SIDE",

  /**
   * value: "DOUBLE_DROP"
   * @const
   */
  "DOUBLE_DROP": "DOUBLE_DROP",

  /**
   * value: "DROP_DECK"
   * @const
   */
  "DROP_DECK": "DROP_DECK",

  /**
   * value: "DROP_DECK_LANDOLL"
   * @const
   */
  "DROP_DECK_LANDOLL": "DROP_DECK_LANDOLL",

  /**
   * value: "DRY_VAN"
   * @const
   */
  "DRY_VAN": "DRY_VAN",

  /**
   * value: "DUMP_TRAILER"
   * @const
   */
  "DUMP_TRAILER": "DUMP_TRAILER",

  /**
   * value: "FLATBED"
   * @const
   */
  "FLATBED": "FLATBED",

  /**
   * value: "FLATBED_53_FOOT"
   * @const
   */
  "FLATBED_53_FOOT": "FLATBED_53_FOOT",

  /**
   * value: "FLATBED_AIR_RIDE"
   * @const
   */
  "FLATBED_AIR_RIDE": "FLATBED_AIR_RIDE",

  /**
   * value: "FLATBED_CONESTOGA"
   * @const
   */
  "FLATBED_CONESTOGA": "FLATBED_CONESTOGA",

  /**
   * value: "FLATBED_DOUBLE"
   * @const
   */
  "FLATBED_DOUBLE": "FLATBED_DOUBLE",

  /**
   * value: "FLATBED_HOTSHOT"
   * @const
   */
  "FLATBED_HOTSHOT": "FLATBED_HOTSHOT",

  /**
   * value: "FLATBED_MAXI"
   * @const
   */
  "FLATBED_MAXI": "FLATBED_MAXI",

  /**
   * value: "FLATBED_OVERDIMENSION"
   * @const
   */
  "FLATBED_OVERDIMENSION": "FLATBED_OVERDIMENSION",

  /**
   * value: "HOPPER"
   * @const
   */
  "HOPPER": "HOPPER",

  /**
   * value: "HOPPER_BOTTOM"
   * @const
   */
  "HOPPER_BOTTOM": "HOPPER_BOTTOM",

  /**
   * value: "INSULATED_VAN"
   * @const
   */
  "INSULATED_VAN": "INSULATED_VAN",

  /**
   * value: "LOWBOY"
   * @const
   */
  "LOWBOY": "LOWBOY",

  /**
   * value: "LOWBOY_OVERDIMENSION"
   * @const
   */
  "LOWBOY_OVERDIMENSION": "LOWBOY_OVERDIMENSION",

  /**
   * value: "MOVING_VAN"
   * @const
   */
  "MOVING_VAN": "MOVING_VAN",

  /**
   * value: "OTHER"
   * @const
   */
  "OTHER": "OTHER",

  /**
   * value: "PNEUMATIC"
   * @const
   */
  "PNEUMATIC": "PNEUMATIC",

  /**
   * value: "POWER_ONLY"
   * @const
   */
  "POWER_ONLY": "POWER_ONLY",

  /**
   * value: "REEFER"
   * @const
   */
  "REEFER": "REEFER",

  /**
   * value: "REEFER_AIR_RIDE"
   * @const
   */
  "REEFER_AIR_RIDE": "REEFER_AIR_RIDE",

  /**
   * value: "REEFER_DOUBLE"
   * @const
   */
  "REEFER_DOUBLE": "REEFER_DOUBLE",

  /**
   * value: "REEFER_INTERMODAL"
   * @const
   */
  "REEFER_INTERMODAL": "REEFER_INTERMODAL",

  /**
   * value: "REMOVABLE_GOOSENECK"
   * @const
   */
  "REMOVABLE_GOOSENECK": "REMOVABLE_GOOSENECK",

  /**
   * value: "STEP_DECK"
   * @const
   */
  "STEP_DECK": "STEP_DECK",

  /**
   * value: "STEPDECK_CONESTOGA"
   * @const
   */
  "STEPDECK_CONESTOGA": "STEPDECK_CONESTOGA",

  /**
   * value: "STRAIGHT_BOX_TRUCK"
   * @const
   */
  "STRAIGHT_BOX_TRUCK": "STRAIGHT_BOX_TRUCK",

  /**
   * value: "STRETCH_TRAILER"
   * @const
   */
  "STRETCH_TRAILER": "STRETCH_TRAILER",

  /**
   * value: "TANKER"
   * @const
   */
  "TANKER": "TANKER",

  /**
   * value: "TANKER_ALUMINUM"
   * @const
   */
  "TANKER_ALUMINUM": "TANKER_ALUMINUM",

  /**
   * value: "TANKER_INTERMODAL"
   * @const
   */
  "TANKER_INTERMODAL": "TANKER_INTERMODAL",

  /**
   * value: "TANKER_STEEL"
   * @const
   */
  "TANKER_STEEL": "TANKER_STEEL",

  /**
   * value: "TILT"
   * @const
   */
  "TILT": "TILT",

  /**
   * value: "TRUCK_AND_TRAILER"
   * @const
   */
  "TRUCK_AND_TRAILER": "TRUCK_AND_TRAILER",

  /**
   * value: "VAN_AIR_RIDE"
   * @const
   */
  "VAN_AIR_RIDE": "VAN_AIR_RIDE",

  /**
   * value: "VAN_DOUBLE"
   * @const
   */
  "VAN_DOUBLE": "VAN_DOUBLE",

  /**
   * value: "VAN_INSULATED"
   * @const
   */
  "VAN_INSULATED": "VAN_INSULATED",

  /**
   * value: "VAN_INTERMODAL"
   * @const
   */
  "VAN_INTERMODAL": "VAN_INTERMODAL",

  /**
   * value: "VAN_OPEN_TOP"
   * @const
   */
  "VAN_OPEN_TOP": "VAN_OPEN_TOP",

  /**
   * value: "VAN_ROLLER_BED"
   * @const
   */
  "VAN_ROLLER_BED": "VAN_ROLLER_BED",

  /**
   * value: "VAN_SPRINTER"
   * @const
   */
  "VAN_SPRINTER": "VAN_SPRINTER",

  /**
   * value: "VAN_TRIPLE"
   * @const
   */
  "VAN_TRIPLE": "VAN_TRIPLE",

  /**
   * value: "VAN_VENTED"
   * @const
   */
  "VAN_VENTED": "VAN_VENTED",

  /**
   * value: "VAN_WITH_CURTAINS"
   * @const
   */
  "VAN_WITH_CURTAINS": "VAN_WITH_CURTAINS",

  /**
   * value: "CONTAINER_53_FOOT"
   * @const
   */
  "CONTAINER_53_FOOT": "CONTAINER_53_FOOT"
};
/**
 * Allowed values for the <code>mode</code> property.
 * @enum {String}
 * @readonly
 */

RfpRowResponse['ModeEnum'] = {
  /**
   * value: "LTL"
   * @const
   */
  "LTL": "LTL",

  /**
   * value: "FTL"
   * @const
   */
  "FTL": "FTL",

  /**
   * value: "VLTL"
   * @const
   */
  "VLTL": "VLTL",

  /**
   * value: "DRYAGE"
   * @const
   */
  "DRYAGE": "DRYAGE",

  /**
   * value: "PARCEL"
   * @const
   */
  "PARCEL": "PARCEL"
};
var _default = RfpRowResponse;
exports["default"] = _default;